import Button from '@pelckmans/elementis/components/button';
import Dialog from '@pelckmans/elementis/components/dialog';
import { useTranslation } from 'react-i18next';

type Props = {
  onClose: () => void;
};

function StudentsFooter({ onClose }: Props) {
  const { t } = useTranslation();

  return (
    <Dialog.Footer
      buttonGroupPropsRight={{
        'aria-label': undefined,
        role: undefined,
        children: (
          <Button prominence="neutral" onClick={onClose}>
            {t('PAGES.MY_GROUPS.MODALS.GROUP_DETAILS.TABS.STUDENTS.FOOTER.ACTIONS.CLOSE')}
          </Button>
        ),
      }}
    />
  );
}

export default StudentsFooter;
